import { component } from 'picoapp';
import debounce from 'lodash/debounce';

interface Sources {
  default: string;
  [key: string]: string | undefined;
}

type Video = {
  src: string,
  bp: number // breakpoint
};

export default component((node: HTMLVideoElement) => {
  const sourcesJson = node.querySelector<HTMLScriptElement>('[data-sources]');
  const sources: Sources = JSON.parse(sourcesJson.innerHTML);
  let matchingSrc = sources.default;

  // construct video objects
  const videos: Video[] = Object.entries(sources).map(
    ([key, val]) => ({ src: val, bp: Number(key) || 0 }),
  );

  const setBestSource = () => {
    const videosMatchingBp = videos.filter((vid) => vid.bp <= document.body.clientWidth);

    if (videosMatchingBp.length) {
      const videoWithHighestMatchingBp = videosMatchingBp.reduce(
        (prev, curr) => (prev.bp > curr.bp ? prev : curr),
      );

      matchingSrc = videoWithHighestMatchingBp.src;
    }

    node.src = matchingSrc || videos[0].src;
  };

  setBestSource();
  let windowWidth = window.innerWidth;

  window.addEventListener('resize', debounce(() => {
    if (window.innerWidth !== windowWidth) {
      setBestSource();
      windowWidth = window.innerWidth;
    }
  }, 500));
});
